/**
 * Simple toast notification system
 * Displays error messages at the top of the page
 */

let toastContainer: HTMLDivElement | null = null

const createToastContainer = () => {
  if (toastContainer) return toastContainer

  toastContainer = document.createElement('div')
  toastContainer.id = 'toast-container'
  toastContainer.className = 'fixed top-4 right-4 z-50 space-y-2'
  document.body.appendChild(toastContainer)
  return toastContainer
}

const showToast = (message: string, type: 'error' | 'success' | 'info' = 'error', duration: number = 5000) => {
  const container = createToastContainer()
  
  const toast = document.createElement('div')
  toast.className = `px-4 py-3 rounded-lg shadow-lg max-w-md ${
    type === 'error' ? 'bg-red-50 border border-red-200 text-red-800' :
    type === 'success' ? 'bg-green-50 border border-green-200 text-green-800' :
    'bg-blue-50 border border-blue-200 text-blue-800'
  }`
  
  toast.innerHTML = `
    <div class="flex items-start gap-3">
      <div class="flex-1">
        <p class="text-sm font-medium">${message}</p>
      </div>
      <button class="text-gray-400 hover:text-gray-600" onclick="this.parentElement.parentElement.remove()">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
  `
  
  container.appendChild(toast)
  
  // Auto-remove after duration
  setTimeout(() => {
    if (toast.parentElement) {
      toast.remove()
    }
  }, duration)
}

export const showError = (message: string) => showToast(message, 'error')
export const showSuccess = (message: string) => showToast(message, 'success')
